import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card } from '@mui/material';
import DescriptionInput from '../../../../forms/description-input';
import NameInput from '../../../../forms/name-input';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },

  imageInputDiv: {
    marginBottom: '2.5em',
  },
};

function BasicForm(props) {
  const {
    onChange, isValidCallback, value,
  } = props;
  useEffect(() => {
    if (isValidCallback) {
      if (value && value.name && value.name.trim()) {
        isValidCallback(true);
      } else {
        isValidCallback(false);
      }
    }
  });
  return (
    <Card elevation={0}>
      <div style={styles.container}>
        <NameInput
          required
          label="Name"
          value={(value && value.name) || ''}
          onChange={(e) => { onChange({ ...value, name: e.target.value }); }}
        />
        <DescriptionInput
          label="Description"
          value={(value && value.description) || ''}
          onChange={(e) => { onChange({ ...value, description: e.target.value }); }}
        />
      </div>
    </Card>
  );
}

BasicForm.propTypes = {
  value: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  isValidCallback: PropTypes.func,
};

BasicForm.defaultProps = {
  value: {
    name: '',
    description: '',
  },
  isValidCallback: undefined,
};

export default BasicForm;
